/* tslint:disable */
/* eslint-disable */
/**
 * openapi.yml
 * オンラインCE API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CalcCeResult,
} from '../models/index';
import {
    CalcCeResultFromJSON,
    CalcCeResultToJSON,
} from '../models/index';

export interface PostCalcceRequest {
    idToken: string;
    multipartFile: Blob;
    coefficientSetId: string;
}

/**
 * 
 */
export class CalcceApi extends runtime.BaseAPI {

    /**
     * CE計算する
     */
    async postCalcceRaw(requestParameters: PostCalcceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CalcCeResult>> {
        if (requestParameters['idToken'] == null) {
            throw new runtime.RequiredError(
                'idToken',
                'Required parameter "idToken" was null or undefined when calling postCalcce().'
            );
        }

        if (requestParameters['multipartFile'] == null) {
            throw new runtime.RequiredError(
                'multipartFile',
                'Required parameter "multipartFile" was null or undefined when calling postCalcce().'
            );
        }

        if (requestParameters['coefficientSetId'] == null) {
            throw new runtime.RequiredError(
                'coefficientSetId',
                'Required parameter "coefficientSetId" was null or undefined when calling postCalcce().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['idToken'] != null) {
            formParams.append('idToken', requestParameters['idToken'] as any);
        }

        if (requestParameters['multipartFile'] != null) {
            formParams.append('multipartFile', requestParameters['multipartFile'] as any);
        }

        if (requestParameters['coefficientSetId'] != null) {
            formParams.append('coefficientSetId', requestParameters['coefficientSetId'] as any);
        }

        const response = await this.request({
            path: `/calcce`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CalcCeResultFromJSON(jsonValue));
    }

    /**
     * CE計算する
     */
    async postCalcce(requestParameters: PostCalcceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CalcCeResult> {
        const response = await this.postCalcceRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
